import { getConfigValue } from 'utils/environment/config';
import { Region } from 'utils/environment/types';

export const PROD_DEFAULT_REGION = (
  getConfigValue({ key: 'buildRegion' }) ?? 'US'
).toUpperCase() as Region;
